import Text, { TextColor } from '@/components/view/atoms/text/Text'
import InsideArea, { BgColor } from '@/components/view/layouts/area/InsideArea'

interface Props {
  slug?: string | null
  pageTitle?: string | null
  metaDescription?: string | null
}

// タイトル/メタディスクリプション/スラッグの入力値のみを反映するクライアントサイドのみのプレビュー（実データ取得は行わない）
const SerpPreview = ({ slug, pageTitle, metaDescription }: Props) => (
  <InsideArea border>
    <div className='flex flex-col gap-1'>
      <Text size={12}>{'https://example.com/' + slug}</Text>
      <Text size={16} color={TextColor.LINK}>
        {pageTitle || '（ページタイトル未設定）'}
      </Text>
      <Text size={12}>{metaDescription || '（メタディスクリプション未設定）'}</Text>
    </div>
  </InsideArea>
)

export default SerpPreview
